<template>
    <div class="d-breadcrumbs">
        <div
            v-for="(breadcrumb, index) in shownBreadcrumbs"
            :key="index"
            class="item"
        >
            <div
                class="text"
            >
                <span
                    class="breadcrumb-contents"
                    :class="[
                        'breadcrumb-contents',
                        breadcrumb.hasError ? 'invalid-value' : '',
                        breadcrumb.key === activeBreadcrumb && breadcrumb.hasError === false ? 'active-breadcrumb' : '',
                        breadcrumb.key === activeBreadcrumb && breadcrumb.hasError === true ? 'active-invalid-breadcrumb' : ''
                    ]"
                    @click="clickBreadcrumb(breadcrumb.key)"
                >
                    <DIcon
                        v-if="breadcrumb.hasError"
                        name="alert"
                    />
                    {{ __(breadcrumb.text) }}
                </span>
            </div>
            <div
                v-if="index !== shownBreadcrumbs.length - 1"
                class="arrow"
            >
                <DIcon name="arrow-right" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    breadcrumbs: {
        type: Array,
        default: () => { return [] }
    },
    activeBreadcrumb: {
        type: String,
        default: () => { return 'basic_information' }
    }
})

const shownBreadcrumbs = computed(() => {
    return props.breadcrumbs.filter(item => item.isShown === true)
})

const emit = defineEmits(['breadcrumb-clicked'])

function clickBreadcrumb (key) {
    emit('breadcrumb-clicked', key)
}
</script>

<style lang="scss" scoped>
.d-breadcrumbs {
    display: flex;
    grid-gap: 15px;
    align-items: center;
    padding-bottom: 15px;
    margin-top: -10px;

    & .item {
        align-items: center;
        display: flex;
        grid-gap: 15px;

        & .breadcrumb-contents {
            cursor: pointer;
            font-size: 1.5em;
            color: rgba(0,0,0);
            transition: 0.2s ease-in-out all;
        }

        & .breadcrumb-contents.invalid-value {
            color: var(--colorDanger);
        }

        & .breadcrumb-contents.active-breadcrumb {
            border-bottom: 2px solid var(--colorPrimaryText);
        }

        & .breadcrumb-contents.active-invalid-breadcrumb {
            border-bottom: 2px solid var(--colorDanger);
        }

        & .arrow {
            color: #222;
            opacity: 0.4;
        }
    }
}
</style>
